export const PROJECT_HISTORY_INIT = 'PROJECT_HISTORY_INIT'
export const PROJECT_HISTORY_REDO_REQUEST = 'PROJECT_HISTORY_REDO_REQUEST'
export const PROJECT_HISTORY_UNDO_REQUEST = 'PROJECT_HISTORY_UNDO_REQUEST'
export const PROJECT_HISTORY_UNDO = 'PROJECT_HISTORY_UNDO'
export const PROJECT_HISTORY_UNDO_TO_THE_START =
  'PROJECT_HISTORY_UNDO_TO_THE_START'
export const PROJECT_HISTORY_SAVE_BACKUP_SNAPSHOT =
  'PROJECT_HISTORY_SAVE_BACKUP_SNAPSHOT'
export const PROJECT_HISTORY_ROLLBACK_TO_BACKUP_SNAPSHOT =
  'HISTORY_ROLLBACK_TO_BACKUP_SNAPSHOT'
